/** Shared Remediation Hub filter bar tokens (shadcn-like density & typography). */

export const FILTER_FONT_SIZE = 13;
export const FILTER_FONT_WEIGHT = 500;
export const FILTER_POPOVER_WIDTH = 272;
export const FILTER_LIST_MAX_HEIGHT = 220;

export const filterTriggerSx = {
  textTransform: "none",
  fontSize: FILTER_FONT_SIZE,
  fontWeight: FILTER_FONT_WEIGHT,
  height: 36,
  minHeight: 36,
  borderRadius: 1.5,
  borderColor: "divider",
  color: "text.primary",
  px: 1.5,
  boxShadow: "none",
  "&:hover": {
    borderColor: "text.secondary",
    backgroundColor: "action.hover",
    boxShadow: "none",
  },
};

export const filterPopoverPaperSx = (width = FILTER_POPOVER_WIDTH) => ({
  width,
  mt: 0.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -2px rgba(0,0,0,0.06)",
  overflow: "hidden",
  fontSize: FILTER_FONT_SIZE,
});

export const filterSearchInputSx = {
  fontSize: FILTER_FONT_SIZE,
  height: 32,
  borderRadius: 1.5,
};

export const filterScrollListSx = {
  maxHeight: FILTER_LIST_MAX_HEIGHT,
  overflowY: "auto",
  py: 0.25,
  "&::-webkit-scrollbar": { width: 6 },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0,0,0,0.18)",
    borderRadius: 3,
  },
};

export const filterListItemSx = {
  py: 0.25,
  px: 1.25,
  minHeight: 32,
  gap: 0.5,
  borderRadius: 1,
  mx: 0.5,
  "&.Mui-selected": {
    backgroundColor: "action.selected",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "action.selected",
  },
};

export const filterListItemTextProps = {
  fontSize: FILTER_FONT_SIZE,
  lineHeight: 1.3,
  fontWeight: 400,
};

export const filterPresetChipSx = {
  height: 24,
  fontSize: 11,
  fontWeight: 500,
  borderRadius: 1.5,
};

export const filterCaptionSx = {
  fontSize: 11,
  fontWeight: 400,
  color: "text.secondary",
};

export const filterSearchFieldSx = {
  width: { xs: "100%", md: 320 },
  "& .MuiInputBase-root": {
    fontSize: FILTER_FONT_SIZE,
    height: 36,
    borderRadius: 1.5,
    backgroundColor: "background.paper",
  },
  "& .MuiInputBase-input": {
    fontSize: FILTER_FONT_SIZE,
    py: 0.75,
  },
};

export const filterActiveChipSx = {
  height: 26,
  fontSize: 12,
  fontWeight: 500,
  borderRadius: 1.5,
};

/** Apply to Remediation Hub page sections for consistent 13px body typography. */
export const remediationHubSx = {
  fontSize: FILTER_FONT_SIZE,
  "& .MuiTableCell-root": { fontSize: FILTER_FONT_SIZE },
  "& .MuiTableHead-root .MuiTableCell-root": {
    fontSize: 12,
    fontWeight: 600,
    color: "text.secondary",
    textTransform: "none",
    letterSpacing: 0,
  },
  "& .MuiTypography-body2": { fontSize: FILTER_FONT_SIZE },
};
